
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes04Off as ObiDiodes04OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-04-off.js';
 
 
 

 
 export const ObiDiodes04Off = createComponent({
   react: React,
   tagName: 'obi-diodes-04-off',
   elementClass: ObiDiodes04OffElement,
   events: {
     
   }
  });
 
 